import React, { useState } from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

const ForgotPassword = () => {
   const [menuOpen, setMenuOpen] =  useState(false);
  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">
        {/* Header */}
        <Header />

      {/* Breadcrumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-1.jpg')",
                backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
          }}
        >
          <img
            src="assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
            
          />

          <div className="container">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Forgot Password</h1>

              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>Forgot Password</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Forgot Password Section */}
        <section className="space-top space-extra-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-5 col-md-7">
                <div className="login-card text-center">
                  <div className="mb-4">
                    <div className="forgot-icon">
                      <i className="far fa-lock-alt"></i>
                    </div>

                    <h2 className="login-card__title mt-3">
                      Forgot Password?
                    </h2>

                    <p className="login-card__sub">
                      Enter your email and we'll send you a reset link.
                    </p>
                  </div>

                  <form className="login-form">
                    <div className="form-group mb-4 text-start">
                      <label className="form-label">
                        Email Address
                      </label>

                      <input
                        type="email"
                        className="form-control"
                        placeholder="your@email.com"
                        required
                      />
                    </div>

                    <button
                      type="submit"
                      className="vs-btn w-100"
                    >
                      Send Reset Link
                    </button>
                  </form>

                  <p className="mt-4 login-card__footer">
                    <Link to="/login" className="auth-link">
                      <i className="far fa-arrow-left me-1"></i>
                      Back to Login
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <Footer />

        {/* Scroll To Top */}
        <ScrollToTop />
      </main>
    </>
  );
};

export default ForgotPassword;